import { create } from "zustand";

export const useVariableStore = create((set) => ({
    value: "",
    setValue: (newValue) => set({ value: newValue }),
}));
